var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.667 18.766c0-4.6 3.733-8.333 8.333-8.333 4.601 0 8.334 3.733 8.334 8.333S24.6 27.1 20 27.1a8.336 8.336 0 0 1-8.334-8.334m8.333-5c-2.759 0-5 2.24-5 5s2.241 5 5 5 5-2.24 5-5-2.24-5-5-5M12.49 31.875c2.154-.918 4.75-1.442 7.51-1.442s5.356.524 7.51 1.442c2.13.907 3.959 2.26 4.982 4.014a1.667 1.667 0 0 1-2.88 1.68c-.542-.93-1.681-1.892-3.409-2.628-1.702-.725-3.849-1.174-6.203-1.174s-4.5.449-6.203 1.174c-1.727.736-2.867 1.698-3.409 2.627a1.667 1.667 0 1 1-2.879-1.68c1.023-1.753 2.852-3.106 4.982-4.013",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 22.1c0-11.046 8.955-20 20-20 11.047 0 20 8.955 20 20 0 3.836-1.099 7.408-2.967 10.448a1.667 1.667 0 1 1-2.84-1.746 16.55 16.55 0 0 0 2.474-8.702c0-9.205-7.46-16.667-16.667-16.667-9.204 0-16.667 7.462-16.667 16.667 0 3.19.913 6.16 2.475 8.702a1.667 1.667 0 1 1-2.84 1.746A19.9 19.9 0 0 1 0 22.1",
    clipRule: "evenodd"
  })));
};
export default SvgUserCircle;